import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Form = styled.form`
  align-items: end;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  gap: 12px;
  margin: 20px 0;

  & > :nth-child(2) {
    width: calc(100% - 125px);
  }

  & > :nth-child(4) {
    width: 50px;
  }

  & > :nth-child(5) {
    flex: 1;
  }

  > span {
    padding-bottom: 4px;
  }
`

export const ModalHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 16px;
  font-weight: bold;
  height: 32px;
  justify-content: space-between;
  position: relative;
`
